import { Pages } from './pages'

export const corporateNoBranchPaths = [
  Pages.dashbord.route,
  Pages.myBranches.route,
  Pages.documents.route,
  Pages.videos.route,
  Pages.troubleshoot.route,
  Pages.branchesManagement.route,
  Pages.accountDetails.route,
]

export const corporateRemoveBranchPaths = [Pages.myBranches.route, Pages.branchesManagement.route]
